import { render } from "./AdvantagesSection.vue?vue&type=template&id=b10219fc&scoped=true"
import script from "./AdvantagesSection.vue?vue&type=script&lang=js"
export * from "./AdvantagesSection.vue?vue&type=script&lang=js"

import "./AdvantagesSection.vue?vue&type=style&index=0&id=b10219fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10219fc"]])

export default __exports__